import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Map, List, fromJS } from 'immutable';

import * as eduActions from 'modules/edu';
import * as currentStatusActions from 'modules/currentStatus';

import { EduContent } from 'components';

let resizeEdu;
let SEARCH_VALUE = '';
class CtEduContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingExam: false,
      isLoadingTag: false,
      isLoadingAttach: false,
      eduScrollData: { isScroll: false, height: 400 },
      searchText: '',
      tempFilter: {},
      filterUpdate: true
    };
  }

  componentDidMount() {
    this.onGetEduTarget(true);
    this.onGetEduExam();
    this.onGetEduTag();
    this.onGetEduAttach();

    window.addEventListener('resize', this.onResize);
  }

  // 태그 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    const rf = this.refScroll;
    if (!!rf && !!rf.scrollable) {
      const { heightData, numberOfChildren } = rf.state.infiniteComputer;
      const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

      // 높이가 달라진 경우
      // 스크롤이 생성 여부
      if (
        rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
        isScroll !== this.state.eduScrollData['isScroll']
      ) {
        this.setState({
          eduScrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
        });
      }
    }

    const { needReload, selectEduNo, eduParam, eduTargetParam, eduSummaryOrdering, eduSummaryByEduNo } = this.props;
    if (
      // 대상자 새로고침
      (needReload && !this.state.isLoading) ||
      // parameter가 변경되었을때
      eduParam !== prevProps.eduParam ||
      // 선택한 교육의 변경되었을 때
      selectEduNo !== prevProps.selectEduNo ||
      // 교육의 데이터가 변경 되었을때
      eduSummaryOrdering !== prevProps.eduSummaryOrdering ||
      eduSummaryByEduNo !== prevProps.eduSummaryByEduNo ||
      // 대상자의 데이터 변경 됬을 때
      eduTargetParam !== prevProps.eduTargetParam
    ) {
      this.onGetEduTarget(true);

      // 새로고침시 스크롤 맨위로 이동
      if (!!rf && !!rf.scrollable) {
        rf.scrollable.scrollTop = 0;
        // rf.infiniteHandleScroll(0);
        // rf.handleScroll(0);
      }
    }

    // if (eduTargetParam !== prevProps.eduTargetParam) {
    //   this.onGetEduTarget(true);
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.onFilterCancel();
  }

  // 브라우저 리사이즈시의 처리
  onResize = () => {
    clearTimeout(resizeEdu);
    resizeEdu = setTimeout(() => {
      this.forceUpdate();
    }, 300);
  };

  // 교육 대상자 리스트
  onGetEduTarget = async refresh => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        const { EduActions, selectEduNo, eduTargetParam, page, totalPages } = this.props;

        if (refresh) {
          const param = {
            eduNo: selectEduNo,
            filter: JSON.stringify(eduTargetParam.get('filter')),
            sort: JSON.stringify(eduTargetParam.get('sort')),
            offset: 0,
            limit: eduTargetParam.get('limit'),
            refresh: !!refresh
          };
          await EduActions.getEduTarget(param);

          setTimeout(() => {
            !!this.refScroll && !!this.refScroll.scrollable && this.refScroll.handleScroll(0);
          }, 500);
        } else if (totalPages > page) {
          const param = {
            eduNo: selectEduNo,
            filter: JSON.stringify(eduTargetParam.get('filter')),
            sort: JSON.stringify(eduTargetParam.get('sort')),
            offset: eduTargetParam.get('limit') * page,
            limit: eduTargetParam.get('limit')
          };

          await EduActions.getEduTarget(param);
        }

        !!eduTargetParam.getIn(['filter', 'searchAll']) &&
          this.setState({ searchText: eduTargetParam.getIn(['filter', 'searchAll']) });
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 전체 훈련 조회
  onGetEduExam = async () => {
    if (!this.state.isLoadingExam) {
      this.setState({ isLoadingExam: true });
      try {
        const { EduActions } = this.props;

        await EduActions.getEduExam();
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoadingExam: false });
    }
  };

  // 전체 태그 조회
  onGetEduTag = async () => {
    if (!this.state.isLoadingTag) {
      this.setState({ isLoadingTag: true });
      try {
        const { EduActions } = this.props;

        await EduActions.getEduTag();
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoadingTag: false });
    }
  };

  // 전체 교육 컨텐츠 조회
  onGetEduAttach = async () => {
    if (!this.state.isLoadingAttach) {
      this.setState({ isLoadingAttach: true });
      try {
        const { EduActions } = this.props;

        await EduActions.getEduAttach();
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoadingAttach: false });
    }
  };

  // 대상자 검색
  onSearchEduTarget = e => {
    let searchValue = '';
    if (e.key === 'Enter' || e.target.id === 'bt-searchTarget' || e.target.parentNode.id === 'bt-searchTarget') {
      searchValue = SEARCH_VALUE;

      const { EduActions, eduTargetParam } = this.props;
      const filter = eduTargetParam.get('filter').toJS();
      if (searchValue !== filter['searchAll']) {
        // filter 지우기
        if (searchValue === '') {
          delete filter['searchAll'];
        } else {
          filter['searchAll'] = searchValue;
        }

        EduActions.changeEduTargetParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 스크롤 ref 등록
  onRefScroll = Scroll => {
    if (!!Scroll) {
      this.refScroll = Scroll;
    }
  };

  // 필터 초기화
  onFilterCancel = () => {
    const { EduActions } = this.props;

    EduActions.changeEduTargetParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // //파라미터 초기값 가져오기
  // getFilterParam = () => {
  //   const { eduParam } = this.props;
  //   const filter = eduParam.get('filter').toJS();
  //   INITIAL_FILTER = Object.assign({}, filter);
  // };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  // 대상자 선택
  handleSelectEduTarget = targetNo => {
    const { selectEduNo } = this.props;
    const { CurrentStatusActions } = this.props;

    if (selectEduNo === 'all') {
      CurrentStatusActions.selectEduTargetNo({ eduTargetNo: 0 });
    } else {
      CurrentStatusActions.selectEduTargetNo({ eduTargetNo: targetNo });
    }
  };

  render() {
    const {
      selectEduNo,
      selectedTag,
      tagDataByTagNo,
      eduTargetOrdering,
      eduTargetDataByTargetNo,
      eduSummaryByEduNo,
      eduParam,
      eduTargetParam,
      eduFilter,
      page,
      totalPages,
      totalEdu
    } = this.props;
    // function
    const {
      onGetEduTarget,
      onSearchChange,
      onSearchEdu,
      handleSelectEduTarget,
      onRefScroll,
      onFilterCancel,
      takeSearchValue,
      searchTextRef,
      onGetEduExam,
      onGetEduTag,
      onSearchEduTarget
    } = this;
    const { tempFilter, filterUpdate, isLoading } = this.state;
    return (
      <EduContent
        tagDataByTagNo={tagDataByTagNo}
        eduTargetOrdering={eduTargetOrdering}
        eduTargetDataByTargetNo={eduTargetDataByTargetNo}
        eduSummaryByEduNo={eduSummaryByEduNo}
        eduParam={eduParam}
        eduTargetParam={eduTargetParam}
        selectEduNo={selectEduNo}
        selectedTag={selectedTag}
        eduScrollData={this.state.eduScrollData}
        isLoading={isLoading}
        page={page}
        totalPages={totalPages}
        totalEdu={totalEdu}
        onGetEduTarget={onGetEduTarget}
        onSearchChange={onSearchChange}
        onSearchEdu={onSearchEdu}
        handleSelectEduTarget={handleSelectEduTarget}
        onRefScroll={onRefScroll}
        onGetEduExam={onGetEduExam}
        onGetEduTag={onGetEduTag}
        // 필터
        searchText={this.state.searchText}
        onSearchEduTarget={onSearchEduTarget}
        eduFilter={eduFilter}
        onFilterCancel={onFilterCancel}
        takeSearchValue={takeSearchValue}
        searchTextRef={searchTextRef}
        tempFilter={tempFilter}
        filterUpdate={filterUpdate}
      />
    );
  }
}

const mapStateToProps = state => ({
  needReload: state.edu.get('needReload'),
  page: state.edu.get('page'),
  totalPages: state.edu.get('totalPages'),
  totalEdu: state.edu.get('totalEdu'),
  eduParam: state.edu.get('param'),
  eduFilter: state.edu.get('filter'),
  // 교육
  eduSummaryOrdering: state.edu.get('eduSummaryOrdering'),
  eduSummaryByEduNo: state.edu.get('eduSummaryByEduNo'),
  // 교육 대상자
  eduTargetOrdering: state.edu.get('eduTargetOrdering'),
  eduTargetDataByTargetNo: state.edu.get('eduTargetDataByTargetNo'),
  eduTargetParam: state.edu.get('targetParam'),
  // selectedEduSummaryNo: state.currentStatus.getIn(['edu', 'selected']),
  selectEduNo: state.currentStatus.getIn(['edu', 'selectEduNo'])
});

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtEduContent);



// WEBPACK FOOTER //
// ./src/script/containers/edu/CtEduContent.js